var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCookie = function SvgCookie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "current",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-80q-83 0-156-31.5T197-197t-85.5-127T80-480q0-75 29-147t81-128.5 125-91T475-881q21 0 43 2t45 7q-9 45 6 85t45 66.5 71.5 36.5 85.5-5q-26 59 7.5 113t99.5 56q1 11 1.5 20.5t.5 20.5q0 82-31.5 154.5t-85.5 127-127 86T480-80m-60-480q25 0 42.5-17.5T480-620t-17.5-42.5T420-680t-42.5 17.5T360-620t17.5 42.5T420-560m-80 200q25 0 42.5-17.5T400-420t-17.5-42.5T340-480t-42.5 17.5T280-420t17.5 42.5T340-360m260 40q17 0 28.5-11.5T640-360t-11.5-28.5T600-400t-28.5 11.5T560-360t11.5 28.5T600-320"
  })));
};
export default SvgCookie;